document.addEventListener('DOMContentLoaded', function() {
  const popupWrap = document.querySelector('.promo-popup-wrap');
  const popupTimeout = parseInt(popupWrap.getAttribute('data-popup-timeout'), 10) * 1000;
  const popupTimes = parseInt(popupWrap.getAttribute('data-popup-times'), 10);
  const closeButton = popupWrap.querySelector('.promo-popup-close');
  const overlay = popupWrap.querySelector('.overlay');
  const form = popupWrap.querySelector('form');

  let popupCounter = sessionStorage.getItem('popupCounter') || 0;
  let formSubmitted = localStorage.getItem('formSubmitted') === 'true';

  function openPopup() {
    popupWrap.style.visibility = 'visible';
    popupWrap.style.opacity = '1';
    popupCounter++;
    sessionStorage.setItem('popupCounter', popupCounter);
  }

  function closePopup() {
    popupWrap.style.visibility = 'hidden';
    popupWrap.style.opacity = '0';
  }

  if (!formSubmitted && popupCounter < popupTimes) {
    setTimeout(openPopup, popupTimeout);
  }

  closeButton.addEventListener('click', function() {
    closePopup();
  });

  closeButton.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      closePopup();
    }
  });

  overlay.addEventListener('click', function() {
    closePopup();
  });

  form.addEventListener('submit', function() {
    localStorage.setItem('formSubmitted', 'true');
  });
});